const footerLinks = {
  about: process.env.REACT_APP_ACUVUE,
  contact: process.env.REACT_APP_CONTACT_US,
  privacy: process.env.REACT_APP_PRIVACY_POLICY,
  legal: process.env.REACT_APP_LEGAL_NOTICE,
  cookiePolicy: process.env.REACT_APP_COOKIE_POLICY,
  patientGuide: process.env.REACT_APP_PATIENT_GUIDE || null,
  warning: process.env.REACT_APP_Warning || null,
};

const socialLinks = {
  facebook: process.env.REACT_APP_FACEBOOK || null,
  twitter: process.env.REACT_APP_TWITTER || null,
  youtube: process.env.REACT_APP_YOUTUBE || null,
  tiktok: process.env.REACT_APP_TIKTOK || null,
  instagram: process.env.REACT_APP_INSTAGRAM || null,
  kakao: process.env.REACT_APP_KAKAO || null,
  weibo: process.env.REACT_APP_WEIBO || null,
  wechat: process.env.REACT_APP_WECHAT || null,
  zhihu: process.env.REACT_APP_ZHIHU || null,
  vk: process.env.REACT_APP_VK || null,
  whatsapp: null,
};

const socialIcons = {
  facebook: require("../assets/imgs/socials/facebook.svg"),
  twitter: require("../assets/imgs/socials/twitter.svg"),
  youtube: require("../assets/imgs/socials/youtube.svg"),
  instagram: require("../assets/imgs/socials/instagram.svg"),
  kakao: require("../assets/imgs/socials/kakao.svg"),
  weixin: require("../assets/imgs/socials/weixin.svg"),
  vk: require("../assets/imgs/socials/vk.svg"),
  whatsapp: require("../assets/imgs/socials/whatsapp.png"),
  tiktok: require("../assets/imgs/socials/tiktok.png"),
  facebook_ph: require("../assets/imgs/socials/facebook.png"),
  instagram_ph: require("../assets/imgs/socials/instagram.png"),
};

export const isEmptySocial = Object.values(socialLinks).every((link) => link);

const FooterConfig = () => {
  return {
    links: {
      parent_link: [
        {
          name: "About",
          className: "link",
          href: footerLinks.about,
          id: "footer.acuvue",
          target: "_blank",
          defaultMessage: "About Acuvue@ Define™",
        },
        {
          name: "Contact",
          className: "link",
          href: footerLinks.contact,
          id: "footer.contact",
          target: "_blank",
          defaultMessage: "Contact Us",
        },
        {
          name: "Privacy Policy",
          className: "link",
          href: footerLinks.privacy,
          id: "footer.privacy",
          target: "_blank",
          defaultMessage: "Privacy Policy",
        },
        {
          name: "Legal",
          className: "link",
          href: footerLinks.legal,
          id: "footer.legal",
          target: "_blank",
          defaultMessage: "Legal Notice",
        },
        {
          name: "Patient Guide",
          className: "link",
          href: footerLinks.patientGuide,
          id: "footer.patientguide",
          target: "_blank",
          defaultMessage: "Patient Instruction Guide",
        },
        {
          name: "Warning",
          className: "link",
          href: footerLinks.warning,
          id: "footer.warning",
          target: "_blank",
          defaultMessage: "Warning",
        },
        {
          name:"Cookie Policy",
          className:"link",
          href: footerLinks.cookiePolicy,
          id: "footer.cookiePolicy",
          target: "_blank",
          defaultMessage:"Cookie Policy",
        }
      ],
      social_link: [
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--facebook",
          icon: process.env.REACT_APP_LOCALE === 'fil' ? socialIcons.facebook_ph : socialIcons.facebook,
          href: socialLinks.facebook,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--tiktok",
          icon: socialIcons.tiktok,
          href: socialLinks.tiktok,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--twitter",
          icon: socialIcons.twitter,
          href: socialLinks.twitter,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--instagram",
          icon: process.env.REACT_APP_LOCALE === 'fil' ? socialIcons.instagram_ph : socialIcons.instagram,
          href: socialLinks.instagram,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--youtube",
          icon: socialIcons.youtube,
          href: socialLinks.youtube,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--kakao",
          icon: socialIcons.kakao,
          href: socialLinks.kakao,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--vk",
          icon: socialIcons.vk,
          href: socialLinks.vk,
          target: "_blank",
        },
        {
          parentClassName: "lists--item",
          className: "link",
          imgClassName: "icons icons--whatsapp",
          icon: socialIcons.whatsapp,
          href: socialLinks.whatsapp,
          target: "_blank",
        },
        // @TODO : Designs are not provided for these imagesand and
        //  currently we are supporting one
        // {
        //   parentClassName: "",
        //   className: "link",
        //   imgClassName: "icons icons--weibo",
        //   icon: null,
        //   href: socialLinks.weibo,
        //   fontAwesomeIcon: true,
        //   target: "_blank",
        // },
        // {
        //   parentClassName: "lists--item",
        //   className: "link",
        //   imgClassName: "icons icons--weixin",
        //   icon: socialIcons.weixin,
        //   href:
        //     socialLinks.wechat &&
        //     require(`../assets/imgs/new/${socialLinks.wechat}`),
        //   target: "_blank",
        // },
        // {
        //   parentClassName: "lists--item",
        //   className: "link",
        //   imgClassName: "icons icons--zhihu",
        //   icon: socialIcons.zhihu,
        //   href: socialLinks.zhihu,
        //   fontAwesomeIcon: true,
        //   target: "_blank",
        // },
      ],
    },
  };
};

export default FooterConfig;
